import cls from "../shop.module.scss";
import Currency from "../../shared/Currency";
import React, {FC} from "react";

interface ITotalProps {
    TotalPriceIntl: string;
    subTotalForCart: string
}

const CartTotalPriceInfo:FC<ITotalProps> = ({ TotalPriceIntl, subTotalForCart }) => {
    return (
        <div className={cls["chekout-total-fms"]}>
            <div className={cls["total-pr-fms"]}>{TotalPriceIntl}</div>
            <div><Currency value={subTotalForCart}/></div>
        </div>
    )
}

export default CartTotalPriceInfo;
